import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SharedModule } from 'src/app/shared/shared.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InsightRoutingModule } from './insight-routing.module';
import { ReminderComponent } from './reminder/reminder.component';


@NgModule({
  declarations: [
    DashboardComponent,
    ReminderComponent
  ],
  imports: [
    CommonModule,
    InsightRoutingModule,
    PerfectScrollbarModule,
    HighchartsChartModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgApexchartsModule,    
  ]
})
export class InsightModule { }
